import config from '@shared/config'

import useBackend from '@shared/hooks/useBackend'

function product() {
  // HOOKS
  const { doGet, doPost, setup } = useBackend()

  // INIT
  setup('/ovpv3/public', config.microserviceBaseUrl)

  // METHODS

  /**
   *  calculateAllPricesForProduct
   *  @param {string} productId
   *  @param {Basket} payload
   *  @returns {PriceCombination[]}
   */
  async function calculateAllPricesForProduct(productId, payload) {
    const priceCalculations = await doPost({ url: `products/${productId}/calculations`, data: payload })
    return priceCalculations.data
  }

  /**
   *  getDefaultOfferProductIds sends a POST-request to 'products/defaultOfferProductIds'
   *  to get the default offer productsIds for each person
   *
   */
  async function getDefaultOfferProductIds(basket) {
    const productIds = await doPost({ url: 'products/defaultOfferProductIds', data: basket })
    return productIds.data
  }

  /**
   *  getProducts gets the productStructure from the ovpv3-ms api
   *  @param {Object} payload
   *  @returns {Promise<ProductStructure>}
   */
  async function getProducts(payload) {
    const response = await doGet({ url: 'products', params: payload })
    return response.data
  }

  return {
    calculateAllPricesForProduct,
    getDefaultOfferProductIds,
    getProducts,
  }
}

export default product()
